module.exports = __webpack_public_path__ + "media/img/home/banner_flashdeal-553b212409f3e1331155393b26465a2c.png";